import { render, staticRenderFns } from "./monitoring-general-page.vue?vue&type=template&id=b1fc9402&"
import script from "./monitoring-general-page.vue?vue&type=script&lang=js&"
export * from "./monitoring-general-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports